import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from './api-client'
import { log } from './utility'

export const fetchCustomerImpact = createAsyncThunk<any,void,{ rejectValue: string }>('customerImpact', async (data, _api) => {
  try {
    const res = await api.getCustomerImpact()

    return res
  } catch (err) {
    return _api.rejectWithValue(err.message || err.msg)
  }
})

export type CustomerImpactStatus = 'idle' | 'loading' | 'success' | 'error'

type CustomerImpactState = {
  data: Record<string, unknown>
  status: CustomerImpactStatus
  error: string
}

const initialState: CustomerImpactState = {
  data: {},
  status: 'idle',
  error: '',
}

const slice = createSlice({
  name: 'customerImpact',
  initialState,
  reducers: {
    clearCustomerImpact: (state): void => {
      state.data = {}
      state.status = 'idle'
      state.error = ''
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerImpact.pending, (state) => {
        state.status = 'loading'
        state.error = ''
      })
      .addCase(fetchCustomerImpact.fulfilled, (state, action) => {
        state.data = action.payload
        state.error = ''
        state.status = 'success'
      })
      .addCase(fetchCustomerImpact.rejected, (state, action) => {
        state.status = 'error'
        log.error(action.payload, { tags: { message: 'error fetching customer impact' } })
        state.error = action.payload || 'Failed to fetch customer impact'
      })
  },
})

export const { clearCustomerImpact } = slice.actions

export default slice.reducer
